import { categories } from '@/mocks/siteData';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-2">
              All Product Categories
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              Click any category to explore products on Basetao Spreadsheet
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 overflow-hidden cursor-pointer"
              >
                <div className="w-full h-28 md:h-32 overflow-hidden rounded-t-xl">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="flex flex-col items-center gap-1.5 p-3 md:p-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 text-center leading-tight">
                    {cat.name}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}